import React from "react";

import ErrorIcon from "../../app/assets/icons/error-icon.svg";
import "./error-message.scss";

interface ErrorMessageComponentProps {
  touched: boolean | undefined;
  error?: string;
}

const ErrorMessageComponent: React.FC<ErrorMessageComponentProps> = ({
  touched,
  error,
}) => {
  return (
    <>
      {touched && error && (
        <div className="error-message-container">
          <div>
            <img src={ErrorIcon} alt="Error Message Icon" className="error-message-icon" />
          </div>
          <span className="error-message-text">{error}</span>
        </div>
      )}
    </>
  );
};

export default ErrorMessageComponent;
